module.exports = __webpack_public_path__ + "static/architecting-tomorrow-banking-aa6ff91341c4d63964379916824d8ad0.jpg";